const host = "https://sllqgujnqe.execute-api.eu-north-1.amazonaws.com";
const externalHost = "https://minasidor.svenskafribrevsbolaget.se";
export default {
  env: "prod",
  domain: host,
  BASE_URL: `${host}/production/`,
  S3_BASE_URL: "https://sfb-app-fs.s3.eu-north-1.amazonaws.com/",
  EXTERNAL_URL: externalHost,
  baseName: "/",
  language: "sv",
  markerDestinationId: "656ca9f7406b387c025517e7",
  sentryURL:
    "https://708d5cd1677b41d284683e898a2c1bb0@o151669.ingest.sentry.io/5705516",
  api: {
    maxAge: 15 * 60 * 1000, // 15 minutes
  },
};
